// @src/pages/Home.jsx
const Home = () => {
    return (
      <div>
        <h1>Home page</h1>
        <p>This route has public access.</p>
      </div>
    );
  };
  export default Home;